import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifierMinus12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMagnifierMinus12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#MagnifierMinus12)">
                    <path
                        fill="currentColor"
                        d="M5.5 0a5.5 5.5 0 0 1 4.2 9.048.5.5 0 0 1 .163.108l1.77 1.77a.5.5 0 0 1-.707.707l-1.77-1.77a.5.5 0 0 1-.108-.163A5.5 5.5 0 1 1 5.5 0m0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m2 4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
                    />
                </g>
                <defs>
                    <clipPath id="MagnifierMinus12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconMagnifierMinus12);
